"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eqObjectInterpreter = exports.eqOrUndefined = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("@morphic-ts/common/lib/utils");
var Eq_1 = require("fp-ts/Eq");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
var asPartialEq = function (x) { return x; };
/**
 *  @since 0.0.1
 */
var eqOrUndefined = function (eq) { return ({
    equals: function (x, y) { return (x === undefined ? y === undefined : y !== undefined && eq.equals(x, y)); }
}); };
exports.eqOrUndefined = eqOrUndefined;
/**
 *  @since 0.0.1
 */
exports.eqObjectInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.EqURI,
    interface: function (props, _name, config) { return function (env) {
        var equals = utils_1.projectFieldWithEnv(props, env)('eq');
        return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.getStructEq(equals), env, { equals: equals }));
    }; },
    // relies on Eq<A> whereas we need Eq<Partial<A>> (but works - covered by tests)
    partial: function (props, _name, config) { return function (env) {
        var equals = utils_1.mapRecord(utils_1.projectFieldWithEnv(props, env)('eq'), exports.eqOrUndefined);
        return new hkt_1.EqType(config_1.eqApplyConfig(config)(asPartialEq(Eq_1.getStructEq(equals)), env, { equals: equals }));
    }; },
    both: function (props, pprops, _name, config) { return function (env) {
        var equalsPartial = utils_1.mapRecord(utils_1.projectFieldWithEnv(pprops, env)('eq'), exports.eqOrUndefined);
        var equals = utils_1.projectFieldWithEnv(props, env)('eq');
        return new hkt_1.EqType(config_1.eqApplyConfig(config)(Eq_1.getStructEq(tslib_1.__assign(tslib_1.__assign({}, equalsPartial), equals)), env, { equalsPartial: equalsPartial, equals: equals }));
    }; }
}); });
